import { taskManagerApiPaths } from '@/hooks/api/_paths'
import { useApiRequest } from '@/lib/http-utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export function useDeleteWorkflowMutation({ workflowId }: { workflowId: string }) {
  const { apiRequest, domainId } = useApiRequest()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['delete-workflow', workflowId],
    mutationFn: async () => {
      const path = taskManagerApiPaths.workflow({ domainId, workflowId })

      const response = await apiRequest({
        path,
        options: { method: 'DELETE' },
      })

      if (!response.ok) {
        throw new Error('FAILED_TO_DELETE_AGENT')
      }

      return true
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: ({ queryKey }) => queryKey.includes('all-workflows'),
      })
    },
  })
}
